import { render, staticRenderFns } from "./Cerrados.vue?vue&type=template&id=fcdd2042&scoped=true"
import script from "./Cerrados.vue?vue&type=script&lang=js"
export * from "./Cerrados.vue?vue&type=script&lang=js"
import style0 from "./Cerrados.vue?vue&type=style&index=0&id=fcdd2042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdd2042",
  null
  
)

export default component.exports